export enum PostingStatusEnum {
	DRAFT = 'DRAFT',
	PUBLISHED = 'PUBLISHED',
	DELETED = 'DELETED',
	DISABLED = 'DISABLED',
	PENDING_DELETE = 'PENDING_DELETE'
}

export enum RandomPostTypeEnum {
	CATEGORY = 'CATEGORY',
	GENRE = 'GENRE',
	MONETIZED = 'MONETIZED'
}

export enum DetailPostTabEnum {
	DETAIL = 'DETAIL',
	BAB = 'BAB',
	OTHER_POST = 'OTHER_POST'
}
